import React from 'react';
import { Radio } from 'antd';
import './index.scss';
import SearchInput from '../../../../../../../../../../Components/SearchItem';
import { CONTROLS_TEXT, MATCH_MODE_OPTIONS } from '../../../../constants';

// The two bands above the participant tables: how everyone gets matched to an
// earlier 360, and a search that narrows both tables at once.
const MatchControls = (props) => (
    <div className='trend-controls'>
        <div className='trend-controls__match'>
            <span className='trend-controls__label'>{CONTROLS_TEXT.matchLabel}</span>
            <Radio.Group
                value={props.matchMode}
                onChange={(event) => props.onChangeMatchMode(event.target.value)}
            >
                {MATCH_MODE_OPTIONS.map((option) => (
                    <Radio key={option.value} value={option.value}>{option.label}</Radio>
                ))}
            </Radio.Group>
            {/* TODO: opens the fixed-date range picker once that flow is designed. */}

        </div>

        <div className='trend-controls__search'>
            <SearchInput
                placeholder={CONTROLS_TEXT.searchPlaceholder}
                value={props.search}
                onChange={({ value }) => props.onChangeSearch(value)}
                clearSearch={props.search ? () => props.onChangeSearch('') : null}
            />
        </div>
    </div>
);

export default MatchControls;
